import { Row } from 'antd';
import { useAccountSelector } from 'src/hooks';

import { ClientServicesLink } from '../ClientServicesLink/ClientServicesLink';
import { MButton } from '../MButton/MButton';
import { MModalV2 } from '../MModal/MModalv2';
import { MTypography } from '../MTypography/MTypography';

interface UntilYourEntityAccountModalProps {
  open: boolean;
  onClose: () => void;
}

export const UntilYourEntityAccountModal = ({ open, onClose }: UntilYourEntityAccountModalProps) => {
  const { account } = useAccountSelector();

  return (
    <MModalV2
      title='Add Another Account'
      width={700}
      height={150}
      open={open}
      onClose={onClose}
      closable
      body={
        <Row>
          <MTypography variant='body1'>
            Until your {account?.customTypeLabel} account is established you cannot create additional accounts under the
            same user. Please contact <ClientServicesLink /> to find out more information.
          </MTypography>
        </Row>
      }
      footer={
        <Row>
          <MButton type='tertiary' onClick={onClose} testId={'until-your-account-btn-close'}>
            Close
          </MButton>
        </Row>
      }
    />
  );
};
